/**
 * Kleine, pure hulpmiddelen bij het bewerken in het beheer: codes (slugs) maken,
 * een concept kopiëren, rijen verplaatsen en de "Wat mist er nog?"-controles tellen.
 * Stijlen staan in admin/ui/styles.ts.
 */

/** Eén regel in "Wat mist er nog?": rood blokkeert, oranje is een aanrader. Gedeeld door catalogus en social. */
export type Check = { level: 'error' | 'warning'; text: string }

export const errorCount = (checks: Check[]) => checks.filter((c) => c.level === 'error').length

/** "Crystal Retinal 1" → "crystal-retinal-1" */
export const slugify = (s: string) =>
  s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

/** Maakt een slug uniek binnen een lijst: "peach-toner-2". */
export const uniqueSlug = (base: string, taken: string[]) => {
  const root = base || 'nieuw'
  let slug = root
  let i = 2
  while (taken.includes(slug)) slug = `${root}-${i++}`
  return slug
}

/** Diepe kopie van platte data (concepten, sjablonen). */
export const clone = <T,>(value: T): T => JSON.parse(JSON.stringify(value)) as T

/** Zet het item op `from` naar `to`. Buiten de lijst: niets verandert. */
export const move = <T,>(list: T[], from: number, to: number): T[] => {
  if (to < 0 || to >= list.length) return list
  const next = [...list]
  const [item] = next.splice(from, 1)
  next.splice(to, 0, item)
  return next
}
